import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtDate, getUser } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Plus, Pencil, Trash2 } from "lucide-react";
import Pagination from "../components/Pagination";
import PageHeader from "../components/PageHeader";

export default function Utilizadores() {
  const [data, setData] = useState({ items: [], page: 1, pages: 1, total: 0 });
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const me = getUser();

  const load = () => api.get("/users", { params: { page } }).then(r => setData(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [page]);

  const openNew = () => { setForm({ name: "", email: "", password: "" }); setEditing(null); setOpen(true); };
  const openEdit = (u) => { setForm({ name: u.name, email: u.email, password: "" }); setEditing(u.id); setOpen(true); };

  const save = async () => {
    try {
      if (editing) {
        const payload = { name: form.name, email: form.email };
        if (form.password) payload.password = form.password;
        await api.put(`/users/${editing}`, payload);
        toast.success("Utilizador atualizado");
      } else {
        if (!form.password) return toast.error("Defina uma password");
        await api.post("/users", form);
        toast.success("Utilizador criado");
      }
      setOpen(false); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const del = async (u) => {
    if (u.id === me?.id) return toast.error("Não pode eliminar a sua própria conta");
    if (!window.confirm(`Eliminar ${u.email}?`)) return;
    await api.delete(`/users/${u.id}`); toast.success("Eliminado"); load();
  };

  return (
    <div data-testid="utilizadores-page">
      <PageHeader title="Utilizadores" subtitle="Gestão de acessos à plataforma" testid="utilizadores-header"
        actions={<Button onClick={openNew} className="bg-[#1E3A8A] hover:bg-[#172554]" data-testid="add-user-btn"><Plus size={16} /> Novo Utilizador</Button>} />

      <div className="a4w-card overflow-hidden">
        <table className="w-full text-sm" data-testid="users-table">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="px-4 py-3 a4w-label">Nome</th>
              <th className="px-4 py-3 a4w-label">Email</th>
              <th className="px-4 py-3 a4w-label">Função</th>
              <th className="px-4 py-3 a4w-label">Criado</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {data.items.map(u => (
              <tr key={u.id} className="border-t border-slate-100 a4w-table-row">
                <td className="px-4 py-3 font-medium">{u.name}</td>
                <td className="px-4 py-3">{u.email}{u.id === me?.id && <span className="text-xs text-slate-400 ml-2">(você)</span>}</td>
                <td className="px-4 py-3 uppercase text-xs font-semibold text-slate-500">{u.role || "admin"}</td>
                <td className="px-4 py-3 text-slate-500">{fmtDate(u.created_at)}</td>
                <td className="px-4 py-3 text-right whitespace-nowrap">
                  <Button size="icon" variant="ghost" onClick={() => openEdit(u)} data-testid={`edit-user-${u.id}`}><Pencil size={16} /></Button>
                  <Button size="icon" variant="ghost" onClick={() => del(u)} disabled={u.id === me?.id} data-testid={`del-user-${u.id}`}><Trash2 size={16} className="text-red-600" /></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination page={data.page} pages={data.pages} total={data.total} onChange={setPage} />

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="user-dialog">
          <DialogHeader><DialogTitle>{editing ? "Editar Utilizador" : "Novo Utilizador"}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="user-name" /></div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="user-email" /></div>
            <div><Label>Password {editing && <span className="text-xs text-slate-400">(deixar vazio para manter)</span>}</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="user-password" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={save} className="bg-[#1E3A8A] hover:bg-[#172554]" data-testid="user-save">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
